import React from 'react';
import { Switch, Router, Route } from 'react-router';
import createHistory from 'history/createBrowserHistory';

import { Step0 } from './components/Step0/Step0';

/**
 * Initialise the history
 */
export const history = createHistory();

/**
 * Define and export the routes
 */
export default () => (
  <Router history={history}>
    <Switch>
      <Route exact path="/" render={routeProps => <Step0 {...routeProps} />} />
    </Switch>
  </Router>
);



// WEBPACK FOOTER //
// ./src/Router.jsx